import { ListingTransactionHistoryProperty } from '../enums';

const ListingTransactionHistoryProps = {
  props: {
    [ListingTransactionHistoryProperty.Tabs]: {
      type: Array,
      required: true,
    },
    [ListingTransactionHistoryProperty.ActiveListingId]: {
      type: Number,
      required: true,
    },
    [ListingTransactionHistoryProperty.Origin]: {
      type: String,
      default: '',
    },
  },
};

export default ListingTransactionHistoryProps;
